<div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">HHG Global Update Rates</legend>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="result">
        <div class="usa-alert usa-alert--success usa-alert--no-icon">
            <div class="usa-alert__body">
                <p class="usa-alert__text">
                    The HHG Global Update has Successfully Updated Records with {{successCount}} Successful Records and {{failureCount}} Failure Records
                </p>
            </div>
        </div>
    </div>
</div>

<form id="hhgRateGlobalUpdateFormGroup" role="form" [formGroup]="hhgRateGlobalUpdateFormFilterGroup">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="transport_type" class="usa-label">Transport Type</label>
            <select id="transport_type" class="maxw-full usa-select" formControlName="transportType" (change)="onTransportTypeChange($event)">
              <option value='' selected disabled>Choose...</option>
              <option *ngFor="let transportType of transportTypeFor">{{transportType}}</option>
            </select>
            <div *ngIf="showGlobalUpdateMessage" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Global update cannot be performed for Canadian and Alaskan locations.
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="transport_type" class="usa-label">Where do you want to apply the change</label>
            <fieldset class="radio-buttons-inline">
                <div class="usa-radio define-space">
                    <input (change)="onItemChange($event.target.value)" class="usa-radio__input define-1" name="global_update_source" id="destination" type="radio" value="destination" checked/>
                    <label class="usa-radio__label" for="destination">Destination</label>
              </div>
              <div class="usa-radio">
                    <input (change)="onItemChange($event.target.value)" class="usa-radio__input" name="global_update_source" id="origin" type="radio" value="origin" />
                    <label class="usa-radio__label" for="origin">Origin</label>
              </div>
            </fieldset>
        </div>

    </div>
    <div class="grid-row grid-gap-1" *ngIf="!this.tspChoice">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="origin" class="usa-label">Origin</label>
            <select id="origin" [attr.disabled]="disableOrigin?'':null" class="maxw-full usa-select"
                formControlName="origin" (change)="onOriginChange($event.target.value)">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let origin of originList" [value]="origin.stateCountryId">
                    {{origin.stateCountryCode}} - {{origin.stateCountryName}}
                </option>
            </select>
            <div *ngIf="showOriginErrorMessage" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{originErrorMessage}}
            </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="destinations_type">Destination Type</label>
            <select id="destinations_type" class="maxw-full usa-select" formControlName="destinationsType"
                (change)="onDestinationTypeChange($event)" [attr.disabled]="disableDestinationType?'':null">
                <option value="" selected disabled>Choose...</option>
                <option value="All Current Destinations">All Current Destinations</option>
                <option value="All Possible Destinations">All Possible Destinations</option>
            </select>
            <ng-container
                *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('destinationsType').value === 'All Current Destinations'">
                <span class="text-base">{{destinationCount}} Records Available for Update</span>
            </ng-container>
        </div>

    </div>

    <div class="grid-row grid-gap-1" *ngIf="this.tspChoice">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="destination" class="usa-label">Destination</label>
            <select id="destination" [attr.disabled]="disableDestination?'':null" class="maxw-full usa-select"
                formControlName="destination" (change)="onDestinationChange($event.target.value)">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let destination of destinationList" [value]="destination.stateCountryId">
                    {{destination.stateCountryCode}} - {{destination.stateCountryName}}
                </option>
            </select>
            <div *ngIf="showOriginErrorMessage" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> {{originErrorMessage}}
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="origin_type">Origin Type</label>
            <select id="origin_type" class="maxw-full usa-select" formControlName="originType"
                (change)="onOriginTypeChange($event)" [attr.disabled]="disableOriginType?'':null">
                <option value="" selected disabled>Choose...</option>
                <option value="All Current Origins">All Current Origins</option>
                <option value="All Possible Origins">All Possible Origins</option>
            </select>
            <ng-container
                *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('originType').value === 'All Current Origins'">
                <span class="text-base">{{originCount}} Records Available for Update</span>
            </ng-container>
        </div>
    </div>



    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="rate_type">Rate Type</label>
            <select id="rate_type" [attr.disabled]="disableRateType?'':null" class="maxw-full usa-select" formControlName="rateType" (change)="onRateTypeChange($event.target.value)">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let rate of ratesList" [value]="rate.rateTypeId">{{rate.rateTypeId}} - {{rate.description}}
                </option>
            </select>
            <div *ngIf="showGlobalUpdateMessage" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Global Updane cannot be performed for Rate Type 11 (Extended Storage Services).
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="agency_id">SRO ID</label>
            <select multiple id="agency_id" [attr.disabled]="disableAgencyId?'':null" class="define-height-usa-select maxw-full usa-select" formControlName="agencyId" (change)="onAgencyIdChange($event.target.value)">
                <option value='' selected disabled>Choose...</option>
                <option *ngFor="let sroId of sroIdList" [value]="sroId.sroMasterId">{{sroId.sroId}}
                </option>
            </select>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="tender_id" class="usa-label">Tender ID</label>
            <input type="text" [attr.disabled]="disableTenderId?'':null" placeholder="Enter Your Tender ID" id="tender_id" class="maxw-full usa-input" formControlName="tenderId" [maxlength]="4" onkeypress="return !(event.charCode == 46)" oninput="this.value = this.value.toUpperCase()"
                (keyup)="onTenderIdChange()">
            <div class="define-text-secondary" *ngIf="this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').invalid && (this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').touched
                                            || this.hhgRateGlobalUpdateFormFilterGroup.get('tenderId').dirty)">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
        </svg> Tender ID must be four characters.
            </div>
        </div>
    </div>
</form>

<form id="hhgRateGlobalUpdateFormGroup_1" role="form" [formGroup]="hhgRateGlobalUpdateFormDiscountGroup">
    <div class="grid-row grid-gap-1 padding-top-4">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
            <h5 class="text-semibold">Discounts</h5>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="usa-alert usa-alert--info usa-alert--no-icon bg-accent-warm define-left-border">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        &#8226; If “All Current Destinations” was selected under “Destination Type,” then one or more of the fields below may be updated. If “All Possible Destinations” was selected, then all of the below fields must be updated.
                    </p>
                    <p class="usa-alert__text">
                        &#8226; If "DOSHW" and "All Possible Destinations" was selected, then TSPs must choose "Replace" and zero fill the UAB and Category 1, 2 and 3 Vehicle fields.
                    </p>
                    <p class="usa-alert__text">
                      &#8226; If "FDICC" and "All Possible Destinations" was selected, then TSPs must choose "Replace" and zero fill the Category 1, 2 and 3 Vehicle fields.
                    </p>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="trans_discount_a" class="usa-label">Transportation %</label>
                    <select id="trans_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="transportation" (change)="onTransportationChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType1">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="trans_discount" class="usa-label">Transportation % Value</label>
                    <input type="text" [attr.disabled]="disableTransportationValue?'':null" placeholder="Enter Transportation % Value Here" id="trans_discount" class="maxw-full usa-input" formControlName="transportationValue" [maxlength]="4" appNumbersOnly (change)="onTransportationValueChange()"
                        onkeypress="return !(event.charCode == 46)" step="1">
                    <div *ngIf="transportationError" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> {{ transportationErrorMessage }}
                    </div>
                    <div *ngIf="transportationWarning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                  </svg> {{ transportationWarningMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showUabAccessorials">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="uab_discount_a">Unaccompanied Air Baggage</label>
                    <select id="uab_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="UAB" (change)="onUABChange()">
                      <option value='' selected>None</option>
                      <option *ngFor="let discountType of discountType1">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="uab_discount">Unaccompanied Air Baggage Value</label>
                    <input type="text" [attr.disabled]="disableUABValue?'':null" appNumbersOnly placeholder="Enter Value Here" id="uab_discount" class="maxw-full usa-input" formControlName="UABValue" [maxlength]="4" (change)="onUabValueChange()" onkeypress="return !(event.charCode == 46)"
                        step="1">
                    <div *ngIf="uabError" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>{{ uabErrorMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value !=='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="sit_discount_a" class="usa-label">Storage-in-Transit</label>
                    <select id="sit_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="storageInTransit" (change)="onStorageInTransitChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType1">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="sit_discount" class="usa-label">Storage-in-Transit Value</label>
                    <input type="text" [attr.disabled]="disableStorageInTransitValue?'':null" placeholder="Enter Value Here" id="sit_discount" class="maxw-full usa-input" appNumbersOnly (change)="onStorageInTransitValueChange()" formControlName="storageInTransitValue" [maxlength]="4"
                        onkeypress="return !(event.charCode == 46)" step="1">
                    <div *ngIf="sitError" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>{{ sitErrorMessage }}
                    </div>
                    <div *ngIf="sitWarning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                        </svg>{{ sitWarningMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="(hhgRateGlobalUpdateFormFilterGroup.get('rateType').value !=='11 - Extended Storage Services') && showUabAccessorials">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="acc_discount_a" class="usa-label">Accessorial Services</label>
                    <select id="acc_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="accessorialServices" (change)="onAccessorialServicesChange()">
                      <option value='' selected>None</option>
                      <option *ngFor="let discountType of discountType1">{{discountType}}</option>
                  </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="acc_discount">Accessorial Services Value</label>
                    <input type="text" [attr.disabled]="disableAccessorialServicesValue?'':null" (change)="onAccessorialServicesValueChange()" placeholder="Enter Value Here" id="acc_discount" class="maxw-full usa-select" appNumbersOnly formControlName="accessorialServicesValue"
                        [maxlength]="4" onkeypress="return !(event.charCode == 46)" step="1">
                    <div *ngIf="accSvcsError" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>{{ accSvcsErrorMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value ==='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="pkg_discount_a" class="usa-label">Packaging/Loading/Drayage</label>
                    <select id="pkg_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="packLoadDrayage" (change)="onPackLoadDrayageChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="pkg_discount" class="usa-label">Packaging/Loading/Drayage Value</label>
                    <input type="text" [attr.disabled]="disablePackLoadDrayageValue?'':null" appNumbersOnly placeholder="Enter Packaging/Loading/Drayage Value Here" id="pkg_discount" class="maxw-full usa-input" formControlName="packLoadDrayageValue" [maxlength]="4">
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value ==='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="warehouse_discount_a" class="usa-label">Warehouse Handling</label>
                    <select id="warehouse_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="warehouseHandling" (change)="onWarehouseHandlingChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="warehouse_discount" class="usa-label">Warehouse Handling Value</label>
                    <input type="text" [attr.disabled]="disableWarehouseHandlingValue?'':null" placeholder="Enter Value Here" id="warehouse_discount" class="maxw-full usa-input" formControlName="warehouseHandlingValue" [maxlength]="4" appNumbersOnly>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value ==='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="storage_discount_a" class="usa-label">Monthly Storage</label>
                    <select id="storage_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full " formControlName="monthlyStorage" (change)="onMonthlyStorageChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="storage_discount" class="usa-label">Monthly Storage Value</label>
                    <input type="text" [attr.disabled]="disableMonthlyStorageValue?'':null" placeholder="Enter Value Here" id="storage_discount" class="usa-input maxw-full" formControlName="monthlyStorageValue" [maxlength]="4" appNumbersOnly>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value ==='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="delivery_discount_a" class="usa-label">Delivery within 50 miles</label>
                    <select id="delivery_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="w-100" formControlName="deliveryWithin50Miles" (change)="onDeliveryWithin50MilesChange()">
                    <option value='' selected>None</option>
                    <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                  </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="delivery_discount" class="usa-label">Delivery within 50 miles Value</label>
                    <input type="text" [attr.disabled]="disableDeliveryWithin50MilesValue?'':null" placeholder="Enter Value Here" id="delivery_discount" class="maxw-full usa-input" formControlName="deliveryWithin50MilesValue" [maxlength]="4" appNumbersOnly>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value ==='11 - Extended Storage Services'">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="handling_discount_a" class="usa-label">Delivery handling out</label>
                    <select id="handling_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="deliveryHandlingOut" (change)="onDeliveryHandlingOutChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="handling_discount">Delivery handling out Value</label>
                    <input type="text" [attr.disabled]="disableDeliveryHandlingOutValue?'':null" placeholder="Enter Value Here" id="handling_discount" class="usa-input maxw-full" formControlName="deliveryHandlingOutValue" [maxlength]="4" appNumbersOnly>
                </div>
            </div>
        </div>
    </div>
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4" *ngIf="showDiscountFieldsText || showDiscountFieldsAlaskaText">
            <div class="usa-alert usa-alert--error usa-alert--no-icon bg-accent-warm define-left-border">
                <div class="usa-alert__body">
                    <p class="usa-alert__text" *ngIf="showDiscountFieldsText">
                        &#8226; Enter vehicle price per mile. Example: enter 50 for $0.50 , 250 for $2.50
                    </p>
                    <p class="usa-alert__text" *ngIf="showDiscountFieldsAlaskaText">
                        &#8226; Enter flat price per vehicle. Example: enter 975 for $975, 3900 for $3,900.
                    </p>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value !== ('11 - Extended Storage Services'
        || '16 - OFM Domestic Drive-away, Tow-away & Carrier-away Services' || '17 - International OFM Vehicles')">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="cat1_discount_a" class="usa-label">Category 1 Vehicle (Less Than 300 cft)</label>
                    <select id="cat1_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="category1Vehicle" (change)="onCategory1VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="cat1_discount" class="usa-label">Category 1 Vehicle (Less Than 300 cft)
                        Value</label>
                    <input type="text" [attr.disabled]="disableCategory1VehicleValue?'':null" placeholder="Enter Value Here" id="cat1_discount" class="maxw-full usa-input" (change)="category1VehicleValueChange()" formControlName="category1VehicleValue" [maxlength]="6" appNumbersOnly>
                    <div *ngIf="class1Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{ class1ErrorMessage }}
                    </div>
                    <div *ngIf="class1Warning" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                        </svg> {{ class1WarningMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value !== ('11 - Extended Storage Services'
        || '16 - OFM Domestic Drive-away, Tow-away & Carrier-away Services' || '17 - International OFM Vehicles')">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="cat2_discount_a" class="usa-label">Category 2 Vehicle (300-800 cft)</label>
                    <select id="cat2_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="category2Vehicle" (change)="onCategory2VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="cat2_discount" class="usa-label">Category 2 Vehicle (300-800 cft)
                        Value</label>
                    <input type="text" [attr.disabled]="disableCategory2VehicleValue?'':null" placeholder="Enter Value Here" id="cat2_discount" class="usa-input maxw-full" (change)="category2VehicleValueChange()" formControlName="category2VehicleValue" [maxlength]="6" appNumbersOnly>
                    <div *ngIf="class2Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>{{ class2ErrorMessage }}
                    </div>
                    <div *ngIf="class2Warning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                        </svg>{{ class2WarningMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="hhgRateGlobalUpdateFormFilterGroup.get('rateType').value !== ('11 - Extended Storage Services'
        || '16 - OFM Domestic Drive-away, Tow-away & Carrier-away Services' || '17 - International OFM Vehicles')">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="cat3_discount_a" class="usa-label">Category 3 Vehicle (> 800 cft)</label>
                    <select id="cat3_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="category3Vehicle" (change)="onCategory3VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="cat3_discount">Category 3 Vehicle (> 800 cft) Value</label>
                    <input type="text" [attr.disabled]="disableCategory3VehicleValue?'':null" placeholder="Enter Value Here" id="cat3_discount" class="usa-input maxw-full" (change)="category3VehicleValueChange()" formControlName="category3VehicleValue" [maxlength]="6" appNumbersOnly>
                    <div *ngIf="class3Error" class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{ class3ErrorMessage }}
                    </div>
                    <div *ngIf="class3Warning" class="text-accent-warm">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#api"></use>
                          </svg> {{ class3WarningMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="showFieldsOnRateType" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="class1_discount_a" class="usa-label">Class1 (1-5,999 GVWR)</label>
                    <select id="class1_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="maxw-full usa-select" formControlName="class1Vehicle" (change)="onClass1VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="class1_discount" class="usa-label">Class1 (1-5,999 GVWR) Value</label>
                    <input type="text" [attr.disabled]="disableClass1Value?'':null" appNumbersOnly placeholder="Enter Value Here" id="class1_discount" class="maxw-full usa-input" formControlName="class1VehicleValue" [maxlength]="5">
                </div>
            </div>
        </div>
        <div *ngIf="showFieldsOnRateType" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="class2_discount_a" class="usa-label">Class2 (6,000 - 11,999 GVWR)</label>
                    <select id="class2_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="class2Vehicle" (change)="onClass2VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="class2_discount" class="usa-label">Class2 (6,000 - 11,999 GVWR) Value</label>
                    <input type="text" [attr.disabled]="disableClass2Value?'':null" appNumbersOnly placeholder="Enter Value Here" id="class2_discount" class="maxw-full usa-input" formControlName="class2VehicleValue" [maxlength]="5">
                </div>
            </div>
        </div>
        <div *ngIf="showFieldsOnRateType" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label for="class3_discount_a" class="usa-label">Class3 (>= 12,000 GVWR)</label>
                    <select id="class3_discount_a" [attr.disabled]="disableDiscountCategory?'':null" class="usa-select maxw-full" formControlName="class3Vehicle" (change)="onClass3VehicleChange()">
                        <option value='' selected>None</option>
                        <option *ngFor="let discountType of discountType2">{{discountType}}</option>
                    </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="class3_discount">Class3 (>= 12,000 GVWR) Value</label>
                    <input type="text" [attr.disabled]="disableClass3Value?'':null" appNumbersOnly placeholder="Enter Value Here" id="class3_discount" class="usa-input maxw-full" formControlName="class3VehicleValue" [maxlength]="5">
                </div>
            </div>
        </div>
    </div>
</form>

<form id="hhgRateGlobalUpdateFormGroup_2" role="form" [formGroup]="hhgRateGlobalUpdateFormAuditGroup">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
            <h5 class="text-semibold">Booking Contact Information</h5>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="phone" class="usa-label">Booking Phone Number</label>
            <input id="phone" class="maxw-full usa-input" formControlName="phone" type="text" onkeypress="return !(event.charCode == 46)" step="1" appNumbersOnly placeholder="Enter Phone Number Here" [maxlength]="15" [attr.disabled]="disableDiscountCategory?'':null">
            <div class="define-text-secondary" *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('phone').hasError('minlength')">
                <span class="fa fa-warning"></span> Phone number must be 10 digits
            </div>
            <div *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('phone').hasError('maxlength')" class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Phone number can not be more than 15 digits
            </div>
            <div class="define-text-secondary" *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('phone').hasError('required') &&
                                        hhgRateGlobalUpdateFormAuditGroup.get('phone').touched">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Phone number is required
            </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="email" class="usa-label">Booking Email</label>
            <input type="text" [attr.disabled]="disableDiscountCategory?'':null" placeholder="Enter Email Here" id="email" class="maxw-full usa-input" formControlName="email">
            <div class="define-text-secondary" *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('email').hasError('email') &&
                                        hhgRateGlobalUpdateFormAuditGroup.get('email').touched">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Enter a valid email
            </div>
            <div class="define-text-secondary" *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('email').hasError('required') &&
                                        hhgRateGlobalUpdateFormAuditGroup.get('email').touched">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Email is required
            </div>
            <div class="define-text-secondary" *ngIf="hhgRateGlobalUpdateFormAuditGroup.get('email').hasError('pattern') &&
                                        hhgRateGlobalUpdateFormAuditGroup.get('email').touched">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Email is invalid
            </div>
        </div>
    </div>
</form>
<div class="padding-top-2">
    <button type="button" class="usa-button" [disabled]="hhgRateGlobalUpdateFormDiscountGroup.invalid ||
          hhgRateGlobalUpdateFormAuditGroup.invalid || disableSave()" (click)="onSave()">Save
          </button>
</div>
